import BaseRepository from "./base.repo";
import { HttpStatusCode } from "axios";

class ProfileRepository extends BaseRepository {
  async get() {
    try {
      const response = await this.client.get(`/profile`);
      if (response.status === HttpStatusCode.Ok) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async updatePassword(data: any) {
    let result = false;
    try {
      const response = await this.client.put(`/profile/update-password`, data);
      if (response.status === HttpStatusCode.Ok) {
        this.successToast("Password updated successfully");
        result = true;
      }
    } finally {
      return result;
    }
  }
}

export default ProfileRepository;
